<template>
  <DefaultLayout>
    <smartsupp-live-chat />
    <spinner />
    <div id="order_wizard" v-if="initialized">
      <ScWizardSteps :steps="steps" :active="activeStep" @click="onWizardStepClick"/>
      <div class="container">
        <router-view />
      </div>
    </div>
    <div id="init-error" v-if="error">
      {{ $t('critical_errors.init_error') }}
    </div>
  </DefaultLayout>
</template>

<script>
import { ScWizardSteps } from 'smartcommerce-component-library'
import { ProcessStepLabels } from './utils/ProcessSteps'
import DefaultLayout from '@/shared/components/DefaultLayout'
import { Routes } from './utils/Routes'
import Spinner from './components/Spinner'
import ProductConfigInitializer from './initializers/ProductConfigInitializer'
import BusyService from './services/BusyService'
import { callInitializers } from '../shared/utils/common'
import SmartsuppLiveChat from '../shared/components/SmartsuppLiveChat'

export default {
  components: {
    DefaultLayout,
    ScWizardSteps,
    Spinner,
    SmartsuppLiveChat
  },
  name: 'OrderWizard',
  data () {
    return {
      steps: [],
      activeStep: 0,
      initialized: false,
      error: false
    }
  },
  async mounted () {
    ProcessStepLabels.forEach(label => {
      this.steps.push(this.$t(label))
    })
    this.activeStep = Routes[this.$route.name].activeStep

    let busyId = BusyService.busy()
    try {
      await callInitializers([ProductConfigInitializer], this.$store)
      this.initialized = true
      BusyService.finished(busyId)
    } catch (e) {
      console.log(e)
      this.error = e
      BusyService.finished(busyId)
    }
  },

  methods: {
    onWizardStepClick (index) {
      if (index === this.activeStep) return
      const step = Object.values(Routes).find(route => route.activeStep === index)
      if (!step) return
      this.$router.push({ ...step })
    }
  },

  watch: {
    '$route.name' (newVal, oldVal) {
      if (newVal === oldVal) return
      this.activeStep = Routes[newVal].activeStep
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  padding-top: 50px;
}

#order_wizard {
  font-family: 'Work Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $sc-text-dark;
  text-align: center;

  .sc-gradient-action {
    outline: none;
  }
}

#init-error {
  font-family: 'Work Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $sc-warn;
  text-align: center;
  margin-top: 50px;
  font-size: 32px;
}

/deep/ .sc-wizardsteps-items-container {
  cursor: pointer;
}

@media(max-width: 768px) {
  .container{
    padding-top: 130px;
  }
}
</style>
